import styled, { keyframes } from 'styled-components';

import { colors, cssBreakpoints } from 'theme/theme';

export const NotificationsDropdownIconHolder = styled.div`
  display: inline-flex;
  position: relative;
  width: fit-content;

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    margin-right: 4px;
  }
`;

const animation = keyframes`
   0% { rotate: 0; }
  1% { rotate: 30deg; }
  3% { rotate: -28deg; }
  5% { rotate: 34deg; }
  7% { rotate: -32deg; }
  9% { rotate: 30deg; }
  11% { rotate: -28deg; }
  13% { rotate: 26deg; }
  15% { rotate: -24deg; }
  17% { rotate: 22deg; }
  19% { rotate: -20deg; }
  21% { rotate: 18deg; }
  23% { rotate: -16deg; }
  25% { rotate: 14deg; }
  27% { rotate: -12deg; }
  29% { rotate: 10deg; }
  31% { rotate: -8deg; }
  33% { rotate: 6deg; }
  35% { rotate: -4deg; }
  37% { rotate: 2deg; }
  39% { rotate: -1deg; }
  41% { rotate: 1deg; }
  43% { rotate: 0; }
  100% { rotate: 0; }
`;

export const NotificationsDropdownIconRedDot = styled.div`
  z-index: 1;
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: ${colors.decorativePoppy};
  font-size: 12px;
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${cssBreakpoints.mdDown}) {
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    right: -4px;
    top: -4px;
  }
`;

export const NotificationsDropdownIconWiggle = styled.div`
  display: inline-flex;

  &.animate {
    animation: ${animation} 5s ease-in-out forwards;
  }
`;
